<template>
  <div id="main">
    <div class="video-container">
      <video
        class="video"
        ref="myVideo"
        src="//rightinhome.oss-cn-hangzhou.aliyuncs.com/website/product-h30.mp4"
        muted
        autoplay
        loop
        :poster="require('@/assets/img/product/h30/video_cover.png')"
        @contextmenu.prevent
        playsinline
        preload="auto"
        x5-video-player-type="h5"
        webkit-playsinline="true"
        x5-playsinline="true"
      ></video>
      <img
        class="mask"
        :src="require('@/assets/img/product/h30/mask.png')"
        alt=""
      />
      <p class="title">澜渟 H30 series 盆底康复治疗仪</p>
      <p class="desc">「盆底+私密」对症改善松弛</p>
      <img
        class="price"
        :src="require('@/assets/img/product/h30/price.png')"
        alt=""
      />
      <div class="copyright">
        广告审查批准文号:苏械广审(文)第270729-17656号<br />盆底康复治疗仪
        医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
        禁忌内容或者注意事项详见说明书<br />南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="banner">
      <div id="bannerSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(bannerItem, bannerIndex) in bannerList"
            :key="bannerIndex"
          >
            <div class="img-container">
              <img :src="bannerItem.path" alt="" />
            </div>
            <p class="title">{{ bannerItem.title }}</p>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="img-copyright">
        广告审查批准文号:苏械广审(文)第270731-17967号<br />盆底康复治疗仪
        医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
        禁忌内容或者注意事项详见说明书<br />南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="system">
      <img
        class="bg"
        alt=""
        :src="require('@/assets/img/product/h30/system-bg.png')"
      />
      <p class="title">双向评估标准 科学分析肌底健康</p>
      <div id="systemSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(systemItem, systemIndex) in systemList"
            :key="systemIndex"
          >
            <div class="img-container">
              <img :src="systemItem.path" alt="" />
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="img-copyright">
        广告审查批准文号:苏械广审(文)第270731-17968号<br />盆底康复治疗仪
        医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
        禁忌内容或者注意事项详见说明书<br />南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="pattern">
      <p class="title">生电联合技术  疗程化训练</p>
      <div class="video-list">
        <div class="video-item">
          <video
            src="//rightinhome.oss-cn-hangzhou.aliyuncs.com/website/product-h30-1.mp4"
            muted
            autoplay
            loop
            @contextmenu.prevent
            playsinline="true"
            preload="auto"
            x5-video-player-type="h5"
            webkit-playsinline="true"
            x5-playsinline="true"
          ></video>
          <div class="title">神经肌肉电刺激</div>
          <div class="desc">
            采用双向对称方波技术，针对不同层级细胞肌肉进行激活
          </div>
        </div>
        <div class="video-item" style="margin-bottom: 3.1rem;">
          <video
            src="//rightinhome.oss-cn-hangzhou.aliyuncs.com/website/product-h30-2.mp4"
            muted
            autoplay
            loop
            @contextmenu.prevent
            playsinline="true"
            preload="auto"
            x5-video-player-type="h5"
            webkit-playsinline="true"
            x5-playsinline="true"
          ></video>
          <div class="title">肌电生物反馈</div>
          <div class="desc">
            通过阴道电极采集盆底肌表面的肌电信号转化为可视化图像，搭建盆底肌和中枢神经的联系，建立正确的收缩模式
          </div>
        </div>
      </div>
      <div class="img-copyright" style="color: #ccc;">
        广告审查批准文号:苏械广审(文)第270819-19757号<br />盆底康复治疗仪
        医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
        禁忌内容或者注意事项详见说明书<br />南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="wuxian">
      <img
        class="bg"
        alt=""
        :src="require('@/assets/img/product/h30/wuxian-bg.png')"
      />
      <p class="title">无线体验升级，随享无拘无束</p>
      <div id="wuxianSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(wuxianItem, wuxianIndex) in wuxianList"
            :key="wuxianIndex"
          >
            <div class="img-container">
              <img :src="wuxianItem.path" alt="" />
            </div>
            <p class="title">{{ wuxianItem.title }}</p>
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <div class="img-copyright" style="line-height: 0.8rem;bottom: 0.4rem;">
        广告审查批准文号:苏械广审(文)第270729-17673号<br />盆底康复治疗仪
        医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
        禁忌内容或者注意事项详见说明书<br />南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="zhuanli">
      <p class="title">医疗器械认证及专利</p>
      <p class="sub-title"></p>
      <div class="list">
        <div class="item">
          <img
            v-lazy="require('@/assets/img/product/h30/zhuanli-1.png')"
            class="img"
          />
          <p class="title">盆底康复治疗仪</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img
            v-lazy="require('@/assets/img/product/h30/zhuanli-2.png')"
            class="img"
          />
          <p class="title">盆底评估训练软件</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img
            v-lazy="require('@/assets/img/product/h30/zhuanli-3.png')"
            class="img"
          />
          <p class="title">发明专利</p>
          <p class="desc">ZL 2023 1 1543573.4</p>
        </div>
        <div class="item">
          <img
            v-lazy="require('@/assets/img/product/h30/zhuanli-4.png')"
            class="img"
          />
          <p class="title">发明专利</p>
          <p class="desc">ZL 2023 1 1802368.5</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      rem: document.documentElement.style.fontSize.replace("px", "") * 1,
      bannerSwiper: null,
      bannerList: [
        {
          path: require("@/assets/img/product/h30/banner-1.png"),
          title: "盆底康复系统 提升盆底健康状态"
        },
        {
          path: require("@/assets/img/product/h30/banner-2.png"),
          title: "私密抗衰系统 提升夫妻生活质量"
        }
      ],
      systemSwiper: null,
      systemList: [
        {
          path: require("@/assets/img/product/h30/system-1.png")
        },
        {
          path: require("@/assets/img/product/h30/system-2.png")
        },
        {
          path: require("@/assets/img/product/h30/system-3.png")
        },
        {
          path: require("@/assets/img/product/h30/system-4.png")
        }
      ],
      wuxianSwiper: null,
      wuxianList: [
        {
          path: require("@/assets/img/product/h30/wuxian-1.png"),
          title: "无线一体化"
        },
        {
          path: require("@/assets/img/product/h30/wuxian-2.png"),
          title: "充电收纳一体"
        },
        {
          path: require("@/assets/img/product/h30/wuxian-3.png"),
          title: "全身防水"
        },
        {
          path: require("@/assets/img/product/h30/wuxian-4.png"),
          title: "终生零耗材"
        }
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.bannerSwiper = new Swiper("#bannerSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.systemSwiper = new Swiper("#systemSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.wuxianSwiper = new Swiper("#wuxianSwiper", {
      loop: true, // 循环模式
      width: this.rem * 28,
      spaceBetween: this.rem * 4.7,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
#main {
  background-color: #fff;
}

.video-container {
  position: relative;
  display: flex;

  > .video {
    width: 100%;
    height: 66.7rem;
    object-fit: cover;
  }

  > .mask {
    width: 100%;
    position: absolute;
    bottom: 0;
    pointer-events: none;
  }

  > .title {
    position: absolute;
    bottom: 14.8rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #fff;
    text-align: center;
    line-height: 2.5rem;
  }

  > .desc {
    position: absolute;
    bottom: 12.4rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #fff;
    text-align: center;
    line-height: 2rem;
  }

  > .price {
    width: 14.8rem;
    position: absolute;
    bottom: 8.8rem;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
  }

  > .copyright {
    position: absolute;
    bottom: 2.4rem;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.1rem;
    pointer-events: none;
    font-weight: 400;
  }
}

.banner {
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;

  > #bannerSwiper {
    width: 100%;
    height: 86.6rem;
    position: relative;
    margin: 0 auto;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;

        > img {
          width: 100%;
        }
      }

      > .title {
        position: absolute;
        top: 4rem;
        width: 100%;
        text-align: center;
        font-weight: 500;
        font-size: 1.8rem;
        color: #000000;
        line-height: 2.5rem;
      }
    }

    .swiper-pagination {
      bottom: 2rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: #fff;
      border: 0.1rem solid transparent;
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: transparent;
      border: 0.1rem solid #fff;
    }
  }
}

.system {
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 53.1rem;

  > .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }

  > .title {
    position: absolute;
    top: 4rem;
    z-index: 1;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > #systemSwiper {
    width: 100%;
    height: 33.7rem;
    position: relative;
    top: 12.1rem;
    margin: 0 auto;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 100%;
        height: 100%;
        padding: 0 1.6rem;
        overflow: hidden;
        position: absolute;

        > img {
          width: 100%;
        }
      }

      > .title {
        position: absolute;
        top: 2rem;
        width: 100%;
        font-weight: 500;
        font-size: 1.4rem;
        color: #000000;
        line-height: 2rem;
        text-align: center;
      }

      > .desc {
        position: absolute;
        top: 4.4rem;
        width: 100%;
        font-size: 1.2rem;
        color: #999999;
        line-height: 1.7rem;
        text-align: center;
      }
    }

    .swiper-pagination {
      bottom: 0rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: #fff;
      border: 0.1rem solid transparent;
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: transparent;
      border: 0.1rem solid #fff;
    }
  }
}

.pattern {
  width: 100%;
  height: 73.2rem;
  position: relative;
  background: #ffffff;

  > .title {
    position: absolute;
    top: 4rem;
    z-index: 1;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .video-list {
    width: 100%;
    padding: 0 1.6rem;
    position: absolute;
    top: 10.5rem;
    bottom: 4rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > .video-item {
      border-radius: 2.4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #f5f5f7;
      width: 100%;
      padding-bottom: 1.2rem;

      > video {
        width: 100%;
        height: 19.2rem;
        object-fit: cover;
        border-radius: 2.4rem 2.4rem 0 0;
      }

      > .title {
        margin-top: 1.2rem;
        font-weight: 500;
        font-size: 1.4rem;
        color: #000000;
        text-align: center;
        line-height: 2rem;
      }

      > .desc {
        padding: 0.5rem 1.1rem 0;
        font-weight: 400;
        font-size: 1.2rem;
        color: #666666;
        text-align: center;
        line-height: 1.7rem;
      }
    }
  }
}

.wuxian {
  position: relative;
  width: 100%;
  height: 80.3rem;

  > .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }

  > .title {
    position: absolute;
    top: 4rem;
    z-index: 1;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .swiper {
    position: absolute;
    top: 2.79rem;
    right: 0;
    width: 12.58rem;
    height: 5.93rem;
  }

  > #wuxianSwiper {
    width: 100%;
    height: 29.9rem;
    position: absolute;
    bottom: 4rem;
    overflow: hidden;

    .swiper-wrapper {
      margin-left: 4.7rem;
    }

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 28rem;
        height: 29.9rem;
        overflow: hidden;
        position: absolute;
        border-radius: 2.4rem;

        > img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }

      > .title {
        position: absolute;
        bottom: 1.2rem;
        width: 100%;
        font-weight: 500;
        font-size: 1.4rem;
        color: #000000;
        line-height: 2rem;
        text-align: center;
      }
    }

    /deep/ .swiper-button-prev,
    /deep/ .swiper-button-next {
      color: #fff;

      &:after {
        font-size: 2rem;
        font-weight: 500;
      }
    }
  }
}

.zhuanli {
  position: relative;
  width: 100%;
  height: 58.3rem;
  background: #fafbfe;

  > .title {
    position: absolute;
    top: 4rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
  }

  > .sub-title {
    position: absolute;
    top: 6.9rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
    text-align: center;
  }

  > .list {
    position: absolute;
    top: 12.9rem;
    padding: 0 5.1rem 4rem 6.2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 2.4rem;

    > .item {
      width: 11.62rem;

      > .img {
        width: 11.62rem;
        height: 14.72rem;
      }

      > .title {
        font-weight: 500;
        font-size: 1.3rem;
        color: #000000;
        line-height: 1.8rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.9rem;
      }

      > .desc {
        font-size: 1.1rem;
        color: #999;
        line-height: 1.5rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.6rem;
      }
    }
  }
}
</style>
